import {windowWidth} from "../common";

export default class Teacher {
    constructor() {
        Teacher._filter_prepod_seminar();

        $(document).on('change blur', '#prepod_one', Teacher._filter_prepod_seminar);
    }

    static _filter_prepod_seminar() {
        let checked_input = $('#prepod_one .nearest_seminars_tabs input:checked'),
            checked_select_option = $('#prepod_one .nearest_seminars_tabs_mobile option:selected');
        let current_filter = $(checked_input).attr('id'),
            current_filter_mobile = $(checked_select_option).attr('value'),
            active_tab = $('#prepod_one .nearest_seminars > .wrapper > div');
        if (windowWidth > 769) {
            if ($(active_tab).hasClass(current_filter)) {
                $(active_tab).css("display", "none");
                for (let i = 0; i<active_tab.length; i++) {
                    let curentTab = active_tab[i];
                    if ($(curentTab).hasClass(current_filter)) {
                        $(curentTab).fadeIn(100);
                    }
                }
            }
        } else {
            if ($(active_tab).hasClass(current_filter_mobile)) {
                $(active_tab).css("display", "none");
                for (let i = 0; i<active_tab.length; i++) {
                    let curentTab = active_tab[i];
                    if ($(curentTab).hasClass(current_filter_mobile)) {
                        $(curentTab).fadeIn(100);
                    }
                }
            }
        }
    }
}